var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-word"},[_c('div',{staticClass:"scroll-word-box"},[_c('div',{staticClass:"scroll-word-item"},[_vm._v(_vm._s(_vm.text))]),(_vm.scroll)?_c('div',{staticClass:"scroll-word-item"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }